import React from "react";

import styles from "./InfoCard.module.scss";

type InfoCardProps = {
  title: string;
  subtitle: string | number;
};

export function InfoCard({title, subtitle}: InfoCardProps) {
  return (
    <div className={styles.infoCard}>
      <p className={styles.infoCardTitle}>{title}</p>
      <p className={styles.infoCardSubtitle}>{subtitle}</p>
    </div>
  );
}
